import { Navigate, Route, Routes } from 'react-router-dom';

import OnboardingLayout from '@/component-library/layouts/OnboardingLayout/OnboardingLayout';
import ProtectedLayout from '@/component-library/layouts/ProtectedLayout/ProtectedLayout';
import ClerkSignedInRedirect from '@/component-library/widgets/ClerkSignedInRedirect/ClerkSignedInRedirect';
import { isSingleSendsEnabled } from '@/hooks/useSingleSendsEnabled';
import ChangePhoneNumberPage from '@/modules/Auth/pages/ChangePhoneNumberPage/ChangePhoneNumberPage';
import CreatePasswordPage from '@/modules/Auth/pages/CreatePasswordPage/CreatePasswordPage';
import ForgotPasswordPage from '@/modules/Auth/pages/ForgotPasswordPage/ForgotPasswordPage';
import Pricing from '@/modules/Auth/pages/PricingPage/PricingPage';
import ResetPasswordPage from '@/modules/Auth/pages/ResetPasswordPage/ResetPasswordPage';
import SignInPage from '@/modules/Auth/pages/SignInPage/SignInPage';
import PaddleSignUpPage from '@/modules/Auth/pages/SignUpPage/PaddleSignUpPage';
import SignUpPage from '@/modules/Auth/pages/SignUpPage/SignUpPage';
import VerifyEmailPage from '@/modules/Auth/pages/VerifyEmailPage/VerifyEmailPage';
import ActivityLogs from '@/modules/Dashboard/ActivityLogs/ActivityLogs';
import Audience from '@/modules/Dashboard/Audience/Audience';
import CreateMember from '@/modules/Dashboard/Audience/CreateMember/CreateMember';
import ImportMembers from '@/modules/Dashboard/Audience/ImportMembers/ImportMembers';
import MemberProfile from '@/modules/Dashboard/Audience/MemberProfile/MemberProfile';
import CampaignOverview from '@/modules/Dashboard/Campaigns/CampaignOverview/CampaignOverview';
import CreateCampaign from '@/modules/Dashboard/Campaigns/CreateCampaign/CreateCampaign';
import DeleteCampaign from '@/modules/Dashboard/Campaigns/DeleteCampaign/DeleteCampaign';
import DashboardPage from '@/modules/Dashboard/DashboardPage/DashboardPage';
import Delivery from '@/modules/Dashboard/Delivery/Delivery';
import NotificationOverviewPage from '@/modules/Dashboard/Delivery/OverviewPage/NotificationOverviewPage';
import NewEmailPage from '@/modules/Dashboard/Messages/Emails/NewEmailPage/NewEmailPage';
import CreatePushNotification from '@/modules/Dashboard/Messages/PushNotifications/CreatePushNotifications';
import EnableAndroidPage from '@/modules/Dashboard/Messages/PushNotifications/EnableAndroidPage';
import EnableIosPage from '@/modules/Dashboard/Messages/PushNotifications/EnableIosPage';
import PushNotifications from '@/modules/Dashboard/Messages/PushNotifications/PushNotifications';
import SingleSendsMetricsPage from '@/modules/Dashboard/Messages/SingleSendsMetrics';
import NewSMSPage from '@/modules/Dashboard/Messages/SMS/NewSMSPage/NewSMSPage';
import CreateSegment from '@/modules/Dashboard/Segments/CreateSegment/CreateSegment';
import SegmentOverview from '@/modules/Dashboard/Segments/SegmentOverview/SegmentOverview';
import Segments from '@/modules/Dashboard/Segments/Segments';
import CompanyAccount from '@/modules/Dashboard/Settings/Account/CompanyAccount';
import PersonalAccount from '@/modules/Dashboard/Settings/Account/PersonalAccount/PersonalAccount';
import APICredentials from '@/modules/Dashboard/Settings/APICredentials/APICredentials';
import DeleteAPICredentials from '@/modules/Dashboard/Settings/APICredentials/Delete/DeleteAPICredentials';
import CreateTeamMember from '@/modules/Dashboard/Settings/CreateTeamMember/CreateTeamMember';
import CreateDomain from '@/modules/Dashboard/Settings/Domain/CreateDomain';
import DomainOverview from '@/modules/Dashboard/Settings/Domain/DomainOverview';
import Domains from '@/modules/Dashboard/Settings/Domain/Domains';
import Settings from '@/modules/Dashboard/Settings/Settings';
import TeamMembers from '@/modules/Dashboard/Settings/TeamMembers/TeamMembers';
import SignalsPage from '@/modules/Dashboard/Signals/SignalsPage';
import CreateTemplate from '@/modules/Dashboard/Templates/CreateTemplate/CreateTemplate';
import EditTemplate from '@/modules/Dashboard/Templates/EditTemplate/EditTemplate';
import TemplateOverview from '@/modules/Dashboard/Templates/TemplateOverview/TemplateOverview';
import Templates from '@/modules/Dashboard/Templates/Templates';
import Tickets from '@/modules/Dashboard/Tickets/Tickets';
import WorkspaceDetails from '@/modules/Dashboard/WorkspaceDetails/WorkspaceDetails';
import CreateWorkspace from '@/modules/Dashboard/Workspaces/CreateWorkspace/CreateWorkspace';
import DeleteWorkspace from '@/modules/Dashboard/Workspaces/DeleteWorkspace/DeleteWorkspace';
import EditWorkspace from '@/modules/Dashboard/Workspaces/EditWorkspace/EditWorkspace';
import Workspaces from '@/modules/Dashboard/Workspaces/Workspaces';
import PageNotFound from '@/modules/ErrorPages/PageNotFound/PageNotFound';
import ContactPage from '@/modules/Pages/ContactPage/ContactPage';
import CookiePolicyPage from '@/modules/Pages/CookiePolicyPage/CookiePolicyPage';
import HomePage from '@/modules/Pages/HomePage/HomePage';
import LandingPage from '@/modules/Pages/LandingPage/LandingPage';
import RiskAssessmentPage from '@/modules/Pages/RiskAssessmentPage/RiskAssessmentPage';
import WaitlistPage from '@/modules/Pages/WaitlistPage/WaitlistPage';
import WaitlistThankYouPage from '@/modules/Pages/WaitlistPage/WaitlistThankYouPage';
import { CookieConsentProvider } from '@/modules/Pages/shared/CookieConsent';
import OnboardingPage from '@/modules/Onboarding/pages/OnboardingPage/OnboardingPage';
import StripeCallbackPage from '@/modules/Onboarding/pages/StripeCallbackPage/StripeCallbackPage';
import PublicRoute from '@/utils/routes/PublicRoute';
import { AppRoutes } from '@/utils/routes/router';
import { SingleSends } from '@/utils/routes/Routes';

import '@/utils/interceptors/authSessionInterceptor';

import 'react-loading-skeleton/dist/skeleton.css';

function App() {
  return (
    <div className="bg-center bg-no-repeat h-screen w-full fixed overflow-auto bg-custom-silver">
      {/* Dot Pattern Overlay */}
      {/* <div className="absolute inset-0 overflow-hidden">
        <div className="absolute opacity-10 w-full h-full">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <circle cx="10" cy="10" r="0.8" fill="rgba(255, 255, 255, 0.7)" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid-pattern)" />
          </svg>
        </div>
      </div> */}

      <div className="relative z-10 h-full min-h-0 min-w-0">
          <ClerkSignedInRedirect />
          <CookieConsentProvider>
          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <HomePage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.landing}
              element={
                <PublicRoute>
                  <LandingPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.waitlist}
              element={
                <PublicRoute>
                  <WaitlistPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.waitlistThankYou}
              element={
                <PublicRoute>
                  <WaitlistThankYouPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.riskAssessment}
              element={
                <PublicRoute>
                  <RiskAssessmentPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.signInSplat}
              element={
                <PublicRoute>
                  <SignInPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.pricing}
              element={
                <PublicRoute>
                  <Pricing />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.contactUs}
              element={
                <PublicRoute>
                  <ContactPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.cookies}
              element={
                <PublicRoute>
                  <CookiePolicyPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.signUpSplat}
              element={
                <PublicRoute>
                  <SignUpPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.registerCompanySplat}
              element={
                <PublicRoute>
                  <PaddleSignUpPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.verifyEmail}
              element={
                <PublicRoute>
                  <VerifyEmailPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.forgotPassword}
              element={
                <PublicRoute>
                  <ForgotPasswordPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.createNewPassword}
              element={
                <PublicRoute>
                  <CreatePasswordPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.resetPassword}
              element={
                <PublicRoute>
                  <ResetPasswordPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.changePhoneNumber}
              element={
                <PublicRoute>
                  <ChangePhoneNumberPage />
                </PublicRoute>
              }
            />
            <Route
              path={AppRoutes.onboardingForm}
              element={
                <OnboardingLayout>
                  <OnboardingPage />
                </OnboardingLayout>
              }
            />
            <Route
              path={AppRoutes.stripeCallback}
              element={
                <OnboardingLayout>
                  <StripeCallbackPage />
                </OnboardingLayout>
              }
            />
            <Route
              path={AppRoutes.dashboard}
              element={
                <ProtectedLayout>
                  <DashboardPage />
                </ProtectedLayout>
              }
            />
            {isSingleSendsEnabled() ? (
              <>
                <Route
                  path={AppRoutes.singleSends}
                  element={
                    <ProtectedLayout>
                      <SingleSends />
                    </ProtectedLayout>
                  }
                />
                <Route path={AppRoutes.buildMessage} element={<Navigate to={AppRoutes.singleSendsRoot} replace />} />
                <Route
                  path={AppRoutes.newEmail}
                  element={
                    <ProtectedLayout>
                      <NewEmailPage />
                    </ProtectedLayout>
                  }
                />
                <Route
                  path={AppRoutes.newSMS}
                  element={
                    <ProtectedLayout>
                      <NewSMSPage />
                    </ProtectedLayout>
                  }
                />
              </>
            ) : (
              <>
                <Route path="/single-sends/*" element={<Navigate to={AppRoutes.dashboard} replace />} />
                <Route path="/build-message/*" element={<Navigate to={AppRoutes.dashboard} replace />} />
              </>
            )}
            <Route
              path={AppRoutes.campaignOverview}
              element={
                <ProtectedLayout>
                  <CampaignOverview />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.templateOverview}
              element={
                <ProtectedLayout>
                  <TemplateOverview />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.createCampaign}
              element={
                <ProtectedLayout>
                  <CreateCampaign />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.deleteCampaign}
              element={
                <ProtectedLayout>
                  <DeleteCampaign />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.delivery}
              element={
                <ProtectedLayout>
                  <Delivery />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.members}
              element={
                <ProtectedLayout>
                  <Audience />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.signals}
              element={
                <ProtectedLayout>
                  <SignalsPage />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.tickets}
              element={
                <ProtectedLayout>
                  <Tickets />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.segments}
              element={
                <ProtectedLayout>
                  <Segments />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.segmentOverview}
              element={
                <ProtectedLayout>
                  <SegmentOverview />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.createSegment}
              element={
                <ProtectedLayout>
                  <CreateSegment />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.activityLogs}
              element={
                <ProtectedLayout>
                  <ActivityLogs />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.settings}
              element={
                <ProtectedLayout>
                  <Settings />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.teamMembers}
              element={
                <ProtectedLayout>
                  <TeamMembers />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.account}
              element={
                <ProtectedLayout>
                  <CompanyAccount />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.personalAccount}
              element={
                <ProtectedLayout>
                  <PersonalAccount />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.createTeamMember}
              element={
                <ProtectedLayout>
                  <CreateTeamMember />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.workspaces}
              element={
                <ProtectedLayout>
                  <Workspaces />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.workspaceDetails}
              element={
                <ProtectedLayout>
                  <WorkspaceDetails />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.createWorkspace}
              element={
                <ProtectedLayout>
                  <CreateWorkspace />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.deleteWorkspace}
              element={
                <ProtectedLayout>
                  <DeleteWorkspace />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.editWorkspace}
              element={
                <ProtectedLayout>
                  <EditWorkspace />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.createMember}
              element={
                <ProtectedLayout>
                  <CreateMember />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.importMembers}
              element={
                <ProtectedLayout>
                  <ImportMembers />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.memberProfile}
              element={
                <ProtectedLayout>
                  <MemberProfile />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.templates}
              element={
                <ProtectedLayout>
                  <Templates />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.templatesEdit}
              element={
                <ProtectedLayout>
                  <EditTemplate />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.createTemplate}
              element={
                <ProtectedLayout>
                  <CreateTemplate />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.pushNotifications}
              element={
                <ProtectedLayout>
                  <PushNotifications />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.pushNotificationsEnableIos}
              element={
                <ProtectedLayout>
                  <EnableIosPage />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.pushNotificationsEnableAndroid}
              element={
                <ProtectedLayout>
                  <EnableAndroidPage />
                </ProtectedLayout>
              }
            />
            {isSingleSendsEnabled() && (
              <>
                <Route
                  path={AppRoutes.newPush}
                  element={
                    <ProtectedLayout>
                      <CreatePushNotification />
                    </ProtectedLayout>
                  }
                />
                <Route
                  path={AppRoutes.singleSendsMetrics}
                  element={
                    <ProtectedLayout>
                      <SingleSendsMetricsPage />
                    </ProtectedLayout>
                  }
                />
              </>
            )}
            <Route
              path={AppRoutes.apiCredentials}
              element={
                <ProtectedLayout>
                  <APICredentials />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.deleteAPICredentials}
              element={
                <ProtectedLayout>
                  <DeleteAPICredentials />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.deliveryOverview}
              element={
                <ProtectedLayout>
                  <NotificationOverviewPage />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.domains}
              element={
                <ProtectedLayout>
                  <Domains />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.domainOverview}
              element={
                <ProtectedLayout>
                  <DomainOverview />
                </ProtectedLayout>
              }
            />
            <Route
              path={AppRoutes.createDomain}
              element={
                <ProtectedLayout>
                  <CreateDomain />
                </ProtectedLayout>
              }
            />
            <Route path="/*" element={<PageNotFound />} />
          </Routes>
          </CookieConsentProvider>
      </div>
    </div>
  );
}

export default App;
